import React from "react";
import { Product } from "../constants";
import "../modal.css";
import HealthCsatDone from "./Health/CsatDone";
import TravelCsatDone from "./Travel/CsatDone";
import HomeCsatDone from "./Home/CsatDone";
import ServiceCsatDone from "./ServiceBot/CsatDone";
import TermCsatDone from "./Term/CsatDone";
// import InvestmentCsatDone from "./Investment/CsatDone";
import InvestmentCsatDone from "./Investmentv1/CsatDone";
import MotorCsatDone from "./Motor/CsatDone";
import TwoWheelerCsatDone from "./TwoWheeler/CsatDone";

export default function CsatDone({ clearRoomData, roomId, GAEvent, productId, isService, restartChat, lastMessage, askForRating, option }) {

  const CloseChat = (e) => {
    // e.preventDefault();
    clearRoomData()

    console.log("minimizing ini");
    if (window && window.parent) {
      console.log("minimizing start");
      setTimeout(function () {
        if(lastMessage && lastMessage.type.toLowerCase() === "json" ){
          const content = JSON.parse(lastMessage.content);
          if(content.type === "planSelection")
          window.parent.postMessage({ message: 'Plan Selection.', planSelection: true }, '*');
        }
        console.log('closed from csat')
        if(productId === Product.Investment && !isService){
          window.parent.postMessage({ message: 'Box minimize.', investmentChatMinimize: true , closeChat: true }, '*');
        }else{
          window.parent.postMessage({ message: 'Box minimize.', minimize: true ,  closeChat: true }, '*');
        }
        
      }, 100)
    } else {
      console.log("minimizing not  start");
    }

    if (window.parent?.ReactNativeWebView) {
      setTimeout(function () {
        window.parent.ReactNativeWebView.postMessage('close_webview');
      }, 300)
    }
    if (window?.ReactNativeWebView) {
      setTimeout(function () {
        window?.ReactNativeWebView.postMessage('close_webview');
      }, 300)
    }
  }
  return (
    <>
      {productId === Product.Health && !isService?
        <HealthCsatDone CloseChat={CloseChat} option={option} />
        : null}
      {productId === Product.Travel && !isService?
        <TravelCsatDone CloseChat={CloseChat} />
        : null}      
      {productId === Product.Twowheeler && !isService?
        <TwoWheelerCsatDone CloseChat={CloseChat} />
        : null}
      {productId === Product.Investment && !isService?
        <InvestmentCsatDone CloseChat={CloseChat} />
        : null}
      {productId === Product.Home && !isService?
        <HomeCsatDone
          CloseChat={CloseChat}
        />
        : null}
        {isService?
        <ServiceCsatDone
          CloseChat={CloseChat}
          restartChat={restartChat}
          askForRating={askForRating}
        />
        : null}
        {productId === Product.Term && !isService?
        <TermCsatDone
          CloseChat={CloseChat}
          option={option}
        />
        : null}
        {productId === Product.Motor && !isService?
        <MotorCsatDone
          CloseChat={CloseChat}
        />
        : null}
    </>
  );
}
